'use strict';

export const removeSlashes = (value: string) => {
	return value.replace(/\//gmi, '');
};
